import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@material-ui/core';
import MuiLink from '@material-ui/core/Link';
import ChipInfo from '../../../shared/chip-info';
import { useStyles } from './styles';
import MeditationCard from './meditation-card';
import { ReactComponent as FeedbackIcon } from './feedbackIcon.svg';
import { MeditationContentProps } from './interface';

const feedbackURL = 'https://likemindedcare.typeform.com/to/f5Fzq3Cq#';

export const MeditationContent: FC<MeditationContentProps> = ({
  meditationList,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Typography className={classes.contentTopDescription}>
        {t('v2.exercises.tabView_meditations_label_offerInfo')}
      </Typography>
      <ChipInfo type="info" text={t('v2.global.banner_label_languageInfo')} />
      <Box className={classes.contentWrapper}>
        {meditationList.map((meditation: any) => (
          <Box className={classes.item} key={meditation.name}>
            <MeditationCard audio={meditation} />
          </Box>
        ))}
      </Box>
      <Box className={classes.feedbackLink}>
        <span className={classes.iconWrapper}>
          <FeedbackIcon className={classes.icon} />
        </span>
        <MuiLink
          href={feedbackURL}
          target="_blank"
          variant="body1"
          underline="none"
          className={classes.linkLabel}
        >
          {t('v2.global.button_missingContent')}
        </MuiLink>
      </Box>
    </>
  );
};
